import React from "react";

// import ProfileCard_AccountSettings from "../ProfileCard/ProfileCard"
import SortingPreferences from "./SortingPreferences"
import Sidebar from "../../Components/Sidebar/Sidebar";
import HeadingForAll from "../../Components/HeadingForAll/HeadingForAll";

const AlertServiceSetting = () => {

  
  return(
    <div className="relative">
  <HeadingForAll bigHeading={"My Profile"} isProfile={true} />

  <div className="flex justify-center mt-4">
        <div className="w-full max-w-[1440px]">
          <div className="flex flex-col md:flex-row">
          <div className="flex flex-col items-center w-full gap-2 md:w-1/3">
            <Sidebar />
          </div>
          <div className="flex flex-col w-full gap-8 md:w-2/3">
<SortingPreferences />
            </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default AlertServiceSetting;



